import React from "react";
import { useNavigate } from "react-router-dom";
import "./AddRestaurant.scss";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";

function AddRestaurant() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    setValue,
    trigger,
    formState: { errors },
  } = useForm();

  const onSubmit = () => {
    navigate("/restaurant/addRestaurantCover");
  };
  const handleSelectCategoryChange = (event) => {
    setValue("restaurant_category", event.target.value);
    trigger("restaurant_category");
  };

  const nextPhaseToCover = async () => {
    let restaurant_name = document
      .getElementById("restaurant_name")
      .value.trim();
    let restaurant_category = document.getElementById(
      "restaurant-category"
    ).value;
    let phoneInput = document.getElementById("phone").value;
    console.log({ restaurant_name });
    console.log({ phoneInput });

    dispatch({
      type: "NEXT_PHASE_RESTAURANT",
      payload: {
        restaurant_name: restaurant_name,
        restaurant_category: restaurant_category,
        phone: phoneInput,
      },
    });
  };

  return (
    <div className="AddRestaurant-container">
      <form onSubmit={handleSubmit(onSubmit)} className="AddRestaurant-form">
        <h1>Add Your HomeMade Restaurant Now</h1>
        <label className="restaurant-name-container">
          <input
            autoFocus={true}
            type="text"
            id="restaurant_name"
            placeholder="Restaurant Name"
            className={`${errors.restaurant_name && "invalid"}`}
            {...register("restaurant_name", {
              required: true,
              validate: (value) => value.trim().length > 0,
              minLength: 2,
              maxLength: 50,
            })}
          />

          {errors.restaurant_name &&
            errors.restaurant_name.type === "required" && (
              <span>This field is required</span>
            )}
          {errors.restaurant_name &&
            errors.restaurant_name.type === "validate" && (
              <span>The restaurant name cannot be empty</span>
            )}
          {errors.restaurant_name &&
            errors.restaurant_name.type === "minLength" && (
              <span>
                the Length of the restaurant name must be greater than or equal
                2 characters
              </span>
            )}
          {errors.restaurant_name &&
            errors.restaurant_name.type === "maxLength" && (
              <span>
                the Length of the name-surname must be less than or equal to 50
                characters
              </span>
            )}
        </label>
        <label className="phone-input">
          <input
            {...register("phone", {
              required: true,
              pattern: /^[?\d+]+$/i,
            })}
            id="phone"
            type="tel"
            placeholder="Phone Number"
            className={`${errors.phone && "invalid"}`}
            onKeyUp={() => {
              trigger("phone");
            }}
          />

          {errors.phone && errors.phone.type === "pattern" && (
            <span>invalid phone number</span>
          )}
          {errors.phone && errors.phone.type === "required" && (
            <span>This field is required</span>
          )}
        </label>

        <select
          id="restaurant-category"
          onChange={handleSelectCategoryChange}
          {...register("restaurant_category", {
            required: "Please select a category",
          })}
        >
          <option value="">Select Your Restaurant Category</option>
          <option value="Boulangerie/Patisserie">Boulangerie/Patisserie</option>
          <option value="Brasserie">Brasserie</option>
          <option value="Café">Café</option>
          <option value="Crêperie">Crêperie</option>
          <option value="Bistro">Bistro</option>
          <option value="Fromagerie">Fromagerie</option>
          <option value="Poissonnerie">Poissonnerie</option>
          <option value="Charcuterie">Charcuterie</option>
          <option value="Gastronomic Restaurant">Gastronomic Restaurant</option>
          <option value="Wine Bar">Wine Bar</option>
          <option value="French-Italian Trattoria">
            French-Italian Trattoria
          </option>
          <option value="Vegetarian/Vegan">Vegetarian/Vegan</option>
        </select>
        {errors.restaurant_category && (
          <span>{errors.restaurant_category.message}</span>
        )}

        <input
          type="submit"
          value="Next"
          onClick={nextPhaseToCover}
          id="submit"
          className="AddRestaurant-submit"
        />
      </form>
    </div>
  );
}

export default AddRestaurant;
